import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    name: 'media',
    path: '/media/:abbreviation',
    component: () => import('@/page/media/index.vue')
  },{
    name: 'floorplan',
    path: '/floorplan/:abbreviation/:floorPlanName',
    component: () => import('@/page/floorplan/index.vue')
  },{
    name: 'pdf',
    path: '/pdf/:abbreviation',
    component: () => import('@/page/pdf/index.vue')
  },
  {
    name: 'index',
    path: '/:projectName/:regNum',
    component: () => import('@/page/items/page/info.vue')
  },
  {
    name: 'unitInfo',
    path: '/:projectName/:unitName/:regNum',
    component: () => import('@/page/unitInfo.vue')
  },
  {
    name: 'sharaInfo',
    path: '/sharaInfo',
    component: () => import('@/page/sharaInfo.vue')
  },
  {
    name: 'shareMobile',
    path: '/shareMobile',
    component: () => import('@/page/shareMobile.vue')
  },
  {
    name: 'newShareInfo',
    path: '/newShareInfo',
    component: () => import('@/page/newShareInfo.vue')
  },
  {
    name: 'unitInfo',
    path: '/unitInfo',
    component: () => import('@/page/unitInfo.vue')
  },
  {
    name: 'infoPage',
    path: '/infoPage',
    component: () => import('@/page/items/page/info.vue')
  },
  {
    name: 'mediaPage',
    path: '/mediaPage',
    component: () => import('@/page/items/page/media.vue')
  },
  {
    name: 'Building',
    path: '/Building',
    component: () => import('@/page/items/page/Building.vue')
  },
  {
    name: 'houseType',
    path: '/houseType',
    component: () => import('@/page/items/page/houseType.vue')
  },
  {
    name: 'vsHouse',
    path: '/vsHouse',
    component: () => import('@/page/contrast/vsHouse.vue')
  },
  {
    name: 'vsProject',
    path: '/vsProject',
    component: () => import('@/page/contrast/vsProject.vue')
  },
  {
    name: 'booking',
    path: '/booking',
    component: () => import('@/page/BookAppointment/booking.vue')
  },
  {
    name: 'recommend',
    path: '/recommend',
    component: () => import('@/page/recommend/index.vue') // 推荐
  },
  {
    name: 'compareList',
    path: '/compareList',
    component: () => import('@/page/compareList.vue')
  },
  {
    name: 'projectList',
    path: '/projectList',
    component: () => import('@/page/projectList.vue')
  },
  {
    name: 'itemIndex',
    path: '/:regNum',
    component: () => import('@/page/items/itemIndex.vue')
  },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js